<template>
  <span
    class="inline-flex"
    v-tippy="{ placement: 'top', arrow: true, arrowType: 'default', animation: 'scale' }"
    :title="clicked ? $t('Link copied!') : $t('Click to copy')"
  >
    <button
      type="button"
      class="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-project-500 transition duration-150 ease-in-out whitespace-nowrap bg-transparent border-0 p-0 cursor-pointer"
      @click="copyUrl"
      @mouseleave="mouseleave"
    >
      <svg
        class="w-4 h-4 shrink-0"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <span>{{ $t('Copy URL') }}</span>
    </button>
  </span>
</template>

<script>
  export default {
    props: [
      // Absolute URL to copy. Preferred — the caller knows the canonical URL.
      "url",
      // Legacy fallback for callers that only pass a slug.
      "slug",
    ],
    data: function () {
      return {
        clicked: false
      };
    },
    computed: {
      copyTarget() {
        if (this.url) return this.url;

        // Was window.location.href + "/" + slug, which only produced a valid
        // URL on the index: on an entry's own page it appended the slug to a
        // URL that already had one, and any query string broke it outright.
        const base = window.location.origin + window.location.pathname.replace(/\/+$/, "");
        return base + "/" + this.slug;
      }
    },
    methods: {
      mouseleave() {
        this.clicked = false;
      },
      copyUrl() {
        this.clicked = true;
        navigator.clipboard.writeText(this.copyTarget);
      },
    }
  }
</script>
